(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["komi-sabores"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', async (evento) => {
    const form = evento.target instanceof HTMLFormElement && evento.target.closest('[data-komi-sabor]');
    if (!form) return;
    evento.preventDefault();
    const novo = Number(form.elements.id.value);
    if (novo === Number(form.dataset.atual)) return;
    const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const status = form.querySelector('[role="status"]');
    const botao = form.querySelector('button');
    const cabecalhos = { 'Content-Type': 'application/json', Accept: 'application/json' };
    botao.disabled = true;
    status.textContent = 'Trocando...';
    try {
      // Primeiro põe o sabor novo, depois tira o antigo: se algo falhar no meio, nada some da sacola.
      let r = await fetch(raiz + 'cart/add.js', {
        method: 'POST',
        headers: cabecalhos,
        body: JSON.stringify({
          items: [{ id: novo, quantity: Number(form.dataset.quantidade), properties: JSON.parse(form.dataset.propriedades || '{}') }],
        }),
      });
      if (!r.ok) throw new Error('add');
      r = await fetch(raiz + 'cart/change.js', {
        method: 'POST',
        headers: cabecalhos,
        body: JSON.stringify({ id: form.dataset.linha, quantity: 0 }),
      });
      if (!r.ok) throw new Error('change');
      window.location.reload();
    } catch (erro) {
      status.textContent = 'Não deu pra trocar agora. Tenta de novo.';
      botao.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
